var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2283 1.30207L19.661 14.3228C20.6375 16.0589 19.3897 18.1747 17.3824 18.1747H2.57131C0.563952 18.1747 -0.629612 16.0046 0.346941 14.3228L7.72534 1.30207C8.75615 -0.434024 11.2518 -0.434024 12.2283 1.30207ZM18.4674 15.0823L11.0348 2.06161C10.6007 1.24782 9.40718 1.24782 8.97316 2.06161L1.54051 15.0823C1.05223 15.8419 1.64901 16.8727 2.51706 16.8727H17.3824C18.3589 16.8184 18.9014 15.8419 18.4674 15.0823ZM9.29897 6.40126C9.29897 6.02149 9.62448 5.75022 10.0043 5.75022C10.384 5.75022 10.6553 6.02149 10.6553 6.40126V11.501C10.6553 11.8808 10.384 12.2063 10.0043 12.2063C9.62448 12.2063 9.29897 11.8808 9.29897 11.501V6.40126ZM10.0042 15.0819C10.4924 15.0819 10.8722 14.7021 10.8722 14.2139C10.8722 13.7256 10.4924 13.3458 10.0042 13.3458C9.51589 13.3458 9.13612 13.7256 9.13612 14.2139C9.13612 14.7021 9.51589 15.0819 10.0042 15.0819Z",
    fill: "#D6C228"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.8054d7d9e75bd665034d3220f29b4718.svg";
export { ForwardRef as ReactComponent };